import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { ArticleDetailUtil } from 'shared/models';
import { useSEOLinkBuilder } from '~/utils/build-seo-url';
import { Region, RegionHrefLangMap } from '@lemon8/web-app-shared/i18n';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';
import { loadable } from 'jotai/utils';

export const ArticleCanonical: FC = () => {
  const loadableArticle = useAtomValue(loadable($CurrentAvailableArticleOrNull));
  const buildSEOLink = useSEOLinkBuilder();

  if (loadableArticle.state !== 'hasData' || !loadableArticle.data) {
    return null;
  }

  const article = loadableArticle.data;

  const canonicalUrl = buildSEOLink(ArticleDetailUtil.getArticlePath(article), { fullUrl: true });
  const xDefaultUrl = buildSEOLink(ArticleDetailUtil.getArticleHref(article), { fullUrl: true });

  const hasTranslatedVersion = ArticleDetailUtil.hasTranslatedVersion(article);
  const alternateRegions = [...(article.translatedRegions || []), article.articleRegion];

  return (
    <DynamicHead>
      <link rel="canonical" href={canonicalUrl} />
      {hasTranslatedVersion && (
        <>
          <link rel="alternate" hrefLang="x-default" href={xDefaultUrl} />
          {alternateRegions.map((alternateRegion) => (
            <link
              rel="alternate"
              key={alternateRegion}
              hrefLang={RegionHrefLangMap[alternateRegion as Region]}
              href={buildSEOLink(ArticleDetailUtil.getArticleHref(article, alternateRegion as Region), {
                fullUrl: true,
              })}
            />
          ))}
        </>
      )}
    </DynamicHead>
  );
};
